module.exports = "/static/assets/a80790c977586cc0595b5fe2f0bcb39a.svg";